import { render, staticRenderFns } from "./CompanyContactsTable.vue?vue&type=template&id=21d007b9&"
import script from "./CompanyContactsTable.vue?vue&type=script&lang=js&"
export * from "./CompanyContactsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/blocks/CompanyContactsTable.vue
// module id = null
// module chunks = 